/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交（任务单 DEV-120352）；视觉基准 docs/旅游落地页/cj商旅-01.html。
 * 注意事项：
 * 1. /cj-business-travel 为纯展示型 SSR 落地页（对外投放引流），不调后端接口，仅返回 SEO 与站点名
 *    （结构参照同类落地页 app/web/page/entity/fetch.js）。
 * 2. 同构安全：CommonJS，禁止 import/export 与 fs/path。
 *
 * @param {Object} ctx - SSR 直传 Koa/Egg ctx 或 ssrDataLoader 统一上下文
 * @param {Function} request - 统一请求函数（本页面未使用）
 * @returns {Object} 页面初始化数据，含 __seo、cdnHost、fullName
 */
async function fetchData(ctx, request) {
  let cdnHost = '';
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
  }
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }

  // 站点全名用于 SEO 品牌位（多站点部署时随站点变化），缺省回退 CJdropshipping
  let fullName = '';
  try {
    if (eggCtx && eggCtx.siteCheck && typeof eggCtx.siteCheck.data === 'function') {
      fullName = eggCtx.siteCheck.data('full-name') || '';
    }
  } catch (e) { fullName = ''; }
  if (!fullName && typeof window !== 'undefined' && window.siteCheck && typeof window.siteCheck.data === 'function') {
    try { fullName = window.siteCheck.data('full-name') || ''; } catch (e) { /* ignore */ }
  }
  if (!fullName) { fullName = 'CJdropshipping'; }

  // 站点简称（如 CJ），用于 SEO description 中的品牌位；缺省回退 'CJ'（同 /cj-entity 的取法）
  let siteName = '';
  try {
    if (eggCtx && eggCtx.siteCheck && typeof eggCtx.siteCheck.data === 'function') {
      siteName = eggCtx.siteCheck.data('name') || '';
    }
  } catch (e) { siteName = ''; }
  if (!siteName && typeof window !== 'undefined' && window.siteCheck && typeof window.siteCheck.data === 'function') {
    try { siteName = window.siteCheck.data('name') || ''; } catch (e) { /* ignore */ }
  }
  if (!siteName) { siteName = 'CJ'; }

  return {
    cdnHost: cdnHost,
    fullName: fullName,
    siteName: siteName,
    // 需求来源：docs/旅游落地页/AI提示词.md 第6次补充 —— 业务方给定的 SEO 三项，**文案逐字为准**。
    // 站点名位置按站内惯例做插值（同 app/web/page/entity/fetch.js）：
    //   「| CJdropshipping」→ ${fullName}（siteCheck.data('full-name')，缺省 CJdropshipping）
    //   「with CJ through」→ ${siteName}（siteCheck.data('name')，缺省 CJ）
    // 如此默认站点下渲染结果与给定文案完全一致，多站点下自动替换为对应站点名而不必再改代码。
    // 「CJ Business Travel」是本页产品名（页面 eyebrow 同名），属固定品牌名，不做站点化替换。
    __seo: {
      title: `Customized China Business Travel - CJ Business Travel | ${fullName}`,
      keywords:
        'China business travel, China factory visits, China sourcing trip, private China business tour, China business travel service',
      description:
        `Explore China with ${siteName} through customized business travel, factory visits, sourcing assistance, cultural experiences, and private English-speaking guides.`,
    },
  };
}

module.exports = fetchData;
